var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacilities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.15,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.259 7.893h0-1.911a.35.35 0 0 0-.348.35v1.402c0 .193.156.35.348.35h1.91a8.31 8.31 0 0 0 .696 2.047l-1.35 1.362a.352.352 0 0 0 0 .496s0 0 0 0l1.477 1.486a.346.346 0 0 0 .492 0l1.35-1.36a8.166 8.166 0 0 0 2.034.7v1.924c0 .193.155.35.347.35h1.392a.35.35 0 0 0 .347-.35v-1.921a8.156 8.156 0 0 0 2.032-.701l1.352 1.361a.346.346 0 0 0 .492 0l1.475-1.486a.352.352 0 0 0 0-.496l-1.35-1.364a8.31 8.31 0 0 0 .695-2.047h1.913a.35.35 0 0 0 .348-.35V8.245a.35.35 0 0 0-.348-.35h-1.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87 3.62v5.326c0 .193.155.35.347.35h5.566a.35.35 0 0 0 .347-.35V3.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.783 5.442 4.99-4.357a.347.347 0 0 1 .454 0l4.99 4.357M10.043 9.296V7.544c0-.58-.467-1.05-1.043-1.05-.576 0-1.043.47-1.043 1.05v1.752M11.333 11.048a3.115 3.115 0 0 1-4.668 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities);
export default __webpack_public_path__ + "static/media/facilities.62948c2083535ace8d1846ef1e868984.svg";
export { ForwardRef as ReactComponent };